import { ComponentType } from 'react';
import Code from '@material-ui/icons/Code';
import BarChart from '@material-ui/icons/BarChart';
import Memory from '@material-ui/icons/Memory';
import Chat from '@material-ui/icons/Chat';
import Layers from '@material-ui/icons/Layers';
import Search from '@material-ui/icons/Search';
import Autorenew from '@material-ui/icons/Autorenew';
import AccountTree from '@material-ui/icons/AccountTree';
import Extension from '@material-ui/icons/Extension';
import Build from '@material-ui/icons/Build';
import MenuBook from '@material-ui/icons/MenuBook';

const icons: Record<string, ComponentType<any>> = {
  Code,
  BarChart,
  Memory,
  Chat,
  Layers,
  Search,
  Autorenew,
  AccountTree,
  Extension,
  Build,
};

export const topicIcon = (name: string): ComponentType<any> => icons[name] || MenuBook;
